import {
  FirmAccountType,
  FirmType,
  Maybe,
  OldDealRole,
} from "../graphql/generated";

// convert all upercase to lowercase and replace underscore with space
export function formatEnum(value: string) {
  if (value === "TODO") {
    return "To do";
  }

  return value
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatOldDealRole(role: OldDealRole) {
  switch (role) {
    case OldDealRole.BuyerAdmin:
      return "Buyer Admin";
    case OldDealRole.BuyerStaff:
      return "Buyer";
    case OldDealRole.SellerAdmin:
      return "Seller Admin";
    case OldDealRole.SellerStaff:
      return "Seller";
    case OldDealRole.DealOwner:
      return "Deal Owner";
    case OldDealRole.DealAdmin:
      return "Deal Admin";
    case OldDealRole.GuestAdmin:
      return "Guest";
    case OldDealRole.Guest:
      return "Guest viewer";
    case OldDealRole.DealMember:
      return "Deal Member";
    case OldDealRole.DealAdminViewOnly:
      return "Deal Admin View Only";
    case OldDealRole.GuestUploader:
      return "Guest admin";
    default:
      return "Unknown role";
  }
}

export function formatFirmType(type: FirmType) {
  switch (type) {
    case FirmType.Buyer:
      return "Buyer";
    case FirmType.Seller:
      return "Seller";
    case FirmType.LawFirm:
      return "Law firm";
    case FirmType.Accountant:
      return "Accountant";
    case FirmType.Broker:
      return "Broker";
    case FirmType.Other:
      return "Other";
    default:
      return "Unknown firm type";
  }
}

export function formatFirmAccountType(
  type: Maybe<FirmAccountType> | undefined,
) {
  switch (type) {
    case FirmAccountType.Admin:
      return "Admin";
    case FirmAccountType.Staff:
      return "Staff";
    default:
      return "Unknown account type";
  }
}
